<template>
<div class="row full-width full-height"
  oncontextmenu="return false"
  @dragenter="listen__x__ondragenter"
  @dragleave="listen__x__ondragleave"
  @dragover="listen__x__ondragover"
  @drop="listen__x__ondrop"
  >

  <div class="full-height">
      <sample-image-list
      :images="sampleImages"
      @jobstart="showLayer"
      @joberror="(param) => listen__x__onfileerror(param)"
      @jobdone="(file) => preprocessingFile(file)"
    />
  </div>
  <div class="column col full-width full-height" style="padding:10px 30px 25px 30px;">
    <div style="flex:0 0 40px">
      <div class="row" style="padding-bottom: 6px;">
        <div class="row text-h6">
          {{title}}
          <q-btn dense flat icon="help_outline" @click="state.dialogHelp = true" size="xs" style="margin:3px 0px 0px 3px;" v-show="isDev"/>
        </div>
        <q-space />
        <div class="row text-caption" style="align-items:center">
          <health-check-widget
            ref="health-check"
            :functionCheck="healthCheckFunction"
            :recognizeName="recognizeName"
          />
        </div>
      </div>
    </div>


    <div style="flex:0 0 15px;" />
    <div class="column col bg-white shadow-1 full-width">
      <div class="bg-primary" style="padding:10px 10px;">
        <q-file dark color="white" ref="file" :label=fileLabel v-model="compositionFileData.files" dense accept="image/*,.pdf" @input="preprocessingFile" :disable="checkPermission == false">
          <template v-slot:prepend>
            <q-icon name="attach_file" />
          </template>
        </q-file>     
      </div>
      <q-separator />
      <q-toolbar>
        <q-btn-group class="image-tool-btn-group" unelevated dense>
          <q-btn unelevated color="primary" icon="fit_screen" label="창에 맞춤" :disable="frameData1._empty == true" dense no-caps @click="$refs['image-view1'].fitToWindow()" style="padding:0px 5px;" />
          <q-separator vertical />
          <q-btn unelevated color="primary" :icon="state.bboxShow ? 'check_box' : 'check_box_outline_blank'" label="문자영역 표시" :disable="frameData1._empty == true" dense no-caps @click="listen__btn_bbox__onclick" style="padding:0px 5px;" />
          <q-separator vertical />
          <q-btn unelevated color="primary" icon="compare" label="이미지 수정" :disable="frameData1._empty == true" dense no-caps @click="$refs['image-processing-dialog'].open(frameData0)" style="padding:0px 5px;" />
          <q-separator vertical />
          <q-btn unelevated color="primary" icon="settings" label="옵션" dense no-caps @click="state.dialogOptions.show = true" style="padding:0px 5px;" />
        </q-btn-group>
        <q-space />
        <q-tabs
          v-model="state.tab"
          indicator-color="primary"
          inline-label
          shrink stretch
        >
          <q-tab name="text" icon="list_alt" label="Text" />
          <q-tab name="json" icon="account_tree" label="Json" />
          <q-tab name="image" icon="image" label="Image" />
        </q-tabs>
      </q-toolbar>
      <q-separator />
      <div class="row col full-height full-width">
        <div class="row col full-height full-width">
          <image-view
            ref="image-view1"
            :frame-data="frameData1"
            :pred="pred"
            class="col full-height full-width"
            :passive="false"
            :initial-tool-option="state.currentFrameToolOption"
            :messages-upload=messagesUpload
            @onstatechange="listen__image_view__onstatechange" />
        </div>

        <div class="rtab row full-height full-width" :class="{col: state.tab == 'image'}" style="border-left:1px solid rgb(210, 210, 210);overflow:auto;">
          <q-tab-panels class="row col full-height full-width" v-model="state.tab" animated>
            <q-tab-panel class="full-height column" name="text" style="overflow:hidden;" >
              <div>
                <q-input label="검색..." dense @input.native="listen__text_search__oninput" :value="state.searchText">
                  <template v-slot:prepend>
                    <q-icon name="search"/>
                  </template>
                  <template v-slot:append>
                    <q-icon name="close" @click="state.searchText = ''" class="cursor-pointer" />
                  </template>
                </q-input>
              </div>
              <div v-if="state.searchText != null && state.searchText != ''" class="text-caption text-grey row reverse" style="margin:10px 0px 5px 0px">
                {{ `검색 된 필드: ${searchTexts.length}개 / 검출 된 필드: ${pred.length}개`}}
              </div>
              <div v-else class="text-caption text-grey row reverse" style="margin:10px 0px 5px 0px">
                {{ `검출 된 필드: ${pred.length}개`}}
              </div>
              <div class="col" style="overflow:auto;">
                <template v-for="(field, index) in searchFields">
                  <field-list-item
                    :field="field"
                    :key="`field-${index}`"
                  />
                  <q-separator v-if="index < fields.length - 1" :key="`sep-${index}`" />
                </template>
              </div>
            </q-tab-panel>
            <q-tab-panel name="json">
              <json-viewer :value="jsonData" :expand-depth=3 copyable></json-viewer>
            </q-tab-panel>
            <q-tab-panel name="image" class="full-height full-width" style="padding:0;">
              <image-view
                ref="image-view2"
                :frame-data="frameData2"
                :pred="pred"
                class="col full-height full-width"
                :passive="true"
                :initialFrameState="state.currentFrameState"
                :initial-tool-option="state.currentFrameToolOption" />
            </q-tab-panel>
          </q-tab-panels>
        </div>
      </div>
    </div>
  </div>

  <q-dialog v-model="state.dialogOptions.show">
    <q-card style="width: 300px" class="q-px-sm q-pb-md">
      <q-card-section>
        <div class="text-h6">옵션</div>
      </q-card-section>
      <q-item-label header>문자영역 선 두께</q-item-label>
      <q-item class="row" dense>
        <div class="row" style="align-items:center;flex:0 0 50px;">
          <span>{{ parseInt(state.currentFrameToolOption.lineWidth) }}</span>
        </div>
        <div class="row col" style="align-items:center;justify-content:flex-end">
          <q-slider color="teal" v-model="state.currentFrameToolOption.lineWidth" label :min="1" :max="5" :step="1" />
        </div>
      </q-item>
    </q-card>
  </q-dialog>

  <q-dialog v-model="state.dialogHelp">
    <q-card>
      <q-card-section>
        <div class="text-h6">{{title}}</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        사업자 등록증 이미지를 입력 받아 필드 정보를 추출한다.
        스캔 또는 카메라로 수집된 이미지에 대해 동작 하며 사업자 등록증 영역에 맞게 Crop하여 입력하여야 한다.
        <ul style="margin:3px">
        <li>필드정보 - [과세유형, 등록번호, 법인명, 대표자, 개업연월일, 법인등록번호, 사업장소재지, 본점소재지, 사업의종류, 종목, 발급사유, 과세여부, 발급일, 발급권자]</li>
        </ul>
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;Project Page</div>
        <a href="https://confluence.selvasai.com:8443/pages/viewpage.action?pageId=148243274">https://confluence.selvasai.com:8443/pages/viewpage.action?pageId=148243274</a>
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 관리 담당</div>
        Johan
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 주소</div>
        {{ getAddress() }}
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;ML model</div>
        <ul style="margin:0">
          <li style="word-break: break-all;"><b>text detector:</b>\\fs\영상지능팀\ocr_selvy-ocr\resource\model\text_detector\PaddleOCR\ch_ppocr_server_v2.0_det.pb <i style="color:red">(46.7 MB)</i></li>
          <li style="word-break: break-all;"><b>text recognizer:</b>\\fs\영상지능팀\ocr_selvy-ocr\resource\model\text_recognizer\SelvyOCR\initial_ft__ng__d4__ft__pt__512__ma.pb <i style="color:red">(182 MB)</i></li>
        </ul>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="확인" color="primary" v-close-popup />
      </q-card-actions>
    </q-card>
  </q-dialog>

  <q-inner-loading :showing="state.loadingLayer.show">
    <q-spinner-facebook
        color="primary"
        size="2em"
      />
    {{ state.loadingLayer.message }}
  </q-inner-loading>

  <q-inner-loading :showing="compositionDropData.counterDrag > 0">
    <div class="text-h3">드롭하세요.</div>
  </q-inner-loading>

  <image-processing-dialog ref="image-processing-dialog"
    @done="listen__ip_dialog__done"
  />
</div>
</template>


<script>
import compositionDrop from '@/composition/drop.js'
import compositionFile from '@/composition/file.js'

import MixinLayer from '@/mixins/layer.js'

import ImageProcessingDialog from '@/components/ImageProcessingDialog.vue'
import SampleImageList from '@/components/SampleImageList2.vue'
import ImageView from '@/projects/ocr/views/ImageView.vue'
import FieldListItem from '@/projects/document/components/FieldListItem.vue'
import HealthCheckWidget from '@/components/healthCheckWidget.vue'

import PARSE from '@/js/parse.js'
import MISC from '@/js/miscellaneous.js'
import DocumentOCR from '@/js/document_ocr.js'
import ETC from '@/js/etc.js'
import UserJS from '@/js/user.js'

import _ from 'lodash'
import {getCurrentInstance} from '@vue/composition-api'

export default {
  setup () {
    const vm = getCurrentInstance()
    if (null == vm ) {
      return {}
    }
    const {compositionFileData, preprocessingImageFile} = compositionFile(vm)
    function preprocessingFile(data) {
      const file = data instanceof File ? data : data.file
      return preprocessingImageFile(file, vm.proxy.listen__x__onfilechange, vm.proxy.listen__x__onfileerror)
    }
    const {compositionDropData, listen__x__ondragenter, listen__x__ondragleave, listen__x__ondragover, listen__x__ondrop} = compositionDrop(preprocessingFile)
    return {
      compositionDropData,
      listen__x__ondragenter,
      listen__x__ondragleave,
      listen__x__ondragover,
      listen__x__ondrop,
      compositionDrop,
      compositionFileData,
      preprocessingFile
    }
  },
  mixins: [MixinLayer],
  data: function () {
    return {
      state: {
        dialogHelp: false,
        dialogOptions: {
          show: false
        },
        fitToWindow: false,
        searchText: null,
        tab: 'text',
        currentFrameState: {
          coord: {
            x: 0,
            y: 0
          },
          zoom: undefined,
          voi: {
            windowCenter: 127,
            windowWidth: 256
          }
        },
        currentFrameToolOption: { mouseButtonMask: 2, lineWidth: 2},
        bboxShow: true
      },
      sampleImages: [
        {
          name: '셀바스',
          url: `${process.env.VUE_APP_URL}/api/image/a28e34cf-5045-4e5d-9e96-8966448f3ab9.png`
        },
        {
          name: '셀바스 헬스케어',
          url: `${process.env.VUE_APP_URL}/api/image/BusinessRegistration_002.png`
        }
      ],
      fieldInfo: [
        {
          code: 0,
          name: '이름',
          color: '#e6194b',
          orderY: 3
        },
        {
          code: 1,
          name: '등록번호',
          color: '#3cb44b',
          orderY: 1
        },
        {
          code: 2,
          name: '상호',
          color: '#ffe119',
          orderY: 2
        },
        {
          code: 3,
          name: '개업일자',
          color: '#4363d8',
          orderY: 5
        },
        {
          code: 4,
          name: '과세종류',
          color: '#f58231',
          orderY: 0
        },
        {
          code: 5,
          name: '법인등록번호',
          color: '#911eb4',
          orderY: 6
        },
        {
          code: 6,
          name: '사업장 소재지',
          color: '#42d4f4',
          orderY: 7
        },
        {
          code: 7,
          name: '본점 소재지',
          color: '#f032e6',
          orderY: 8
        },
        {
          code: 8,
          name: '사업의 업태',
          color: '#bfef45',
          orderY: 9
        },
        {
          code: 9,
          name: '사업의 종목',
          color: '#fabed4',
          orderY: 10
        },
        {
          code: 10,
          name: '교부사유',
          color: '#469990',
          orderY: 11
        },
        {
          code: 11,
          name: '발급일자',
          color: '#dcbeff',
          orderY: 13
        },
        {
          code: 12,
          name: '사업자 단위 과세 적용사업자 여부',
          color: '#9A6324',
          orderY: 12
        },
        {
          code: 13,
          name: '발급권자',
          color: '#ffd8b1',
          orderY: 14
        },
        {
          code: 14,
          name: '생년월일',
          color: '#aaffc3',
          orderY: 4
        },
        /*
        {
          code: 99,
          name: '그 외',
          color: '#a9a9a9',
          orderY: 99
        }
        */
      ],
      frameData1: {
        _uid: MISC.getUuid4(),
        _empty: true
      },
      frameData2: {
        _uid: MISC.getUuid4(),
        _empty: true
      },
      pred: [],
      fields: [],
      jsonData: [],
      title: "사업자등록증",
      recognizeName: "br",
    }
  },
  components: {
    ImageProcessingDialog,
    ImageView,
    FieldListItem,
    SampleImageList,
    HealthCheckWidget
  },
  methods: {
    listen__x__onfileerror: function (param) {
      const Vue = this

      Vue.jsonData = []
      Vue.compositionFileData.files = []
      Vue.clearData()
      Vue.hidingLayer()

      let color = param.color
      if (color == undefined)
        color = 'black'

      Vue.$q.notify({
        message: param.message,
        icon: 'announcement',
        color
      })
    },
    listen__x__onfilechange: function (file, options) {
      const Vue = this
      const keepFrameData0 = (options != undefined && options.keepFrameData0 == true) ? true : false
      Vue.clearData(keepFrameData0)
      Vue.showLayer('이미지를 읽는 중...');
      
      MISC.doubleRaf(async () => {
        let image;
        
        let tokens = file.name.split('.');
        let ext = tokens[tokens.length - 1].toLowerCase();
        try {
          image = await PARSE.parseImage(file, ext);
        } catch (err) {
          console.log(err)
          Vue.listen__x__onfileerror({color: 'purple', message: '이미지 읽기에 실패하였습니다'})
          return
        }
        let cornerstoneImage = await Vue.$cornerstone.createCornerstoneImageRgba(undefined, image.pixelData, image.width, image.height);

        Vue.showLayer('인식 중...');
        let ret = {};
        let processingTime
        try {
          const begin = new Date();
          ret = await DocumentOCR.recognizeBusinessRegistration(file)
          processingTime = (new Date() - begin) / 1000
          let pred = []
          for (let i in ret.data.fields) {
            let datum = ret.data.fields[i]
            const idx = Vue.fieldInfo.map(v => v.code).indexOf(datum.type)
            const color = (idx == -1) ? '#000000' : Vue.fieldInfo[idx].color
            
            if (idx == -1)
              continue
            pred.push({
              id: i, text: datum.value, prob: datum.probability,
              key: datum.key,
              active: Vue.state.bboxShow,
              highlight: false,
              color: color,
              points: [
                {x: datum.roi[0][0], y: datum.roi[0][1]},
                {x: datum.roi[1][0], y: datum.roi[1][1]},
                {x: datum.roi[2][0], y: datum.roi[2][1]},
                {x: datum.roi[3][0], y: datum.roi[3][1]},
              ]
            });
          }

          let fields = []
          for (let i in ret.data.fields) {
            let datum = ret.data.fields[i]
            const idx = Vue.fieldInfo.map(v => v.code).indexOf(datum.type)
            const color = (idx == -1) ? '#000000' : Vue.fieldInfo[idx].color

            if (idx == -1)
              continue
            fields.push({
              id: i, color,
              code: Vue.fieldInfo[idx].code,
              name: Vue.fieldInfo[idx].name,
              key: datum.key,
              keyOriginal: datum.keyOriginal,
              value: datum.value,
              valueOriginal: datum.valueOriginal,
              probability: datum.probability,
              roi: datum.roi,
              orderY: Vue.fieldInfo[idx].orderY
            });
          }
          fields.sort((a, b) => a.orderY - b.orderY)

          ret.pred = pred
          ret.fields = fields
        } catch (err) {
          Vue.listen__x__onfileerror({color: 'red', message: err})
          return
        }
        if (keepFrameData0 == true) {
          Vue.frameData1 = {
            id: MISC.getUuid4(),
            name: file.name,
            cornerstoneImage,
            _empty: false
          }
        } else {
          Vue.frameData0 = {
            id: MISC.getUuid4(),
            name: file.name,
            cornerstoneImage,
            _empty: false
          }
          Vue.frameData1 = Vue.frameData0
        }
        let cornerstoneImage2 = await Vue.$cornerstone.createCornerstoneImageRgba(undefined, ret.image.pixelData, ret.image.width, ret.image.height);
        Vue.frameData2 = {
          id: MISC.getUuid4(),
          name: file.name,
          cornerstoneImage: cornerstoneImage2,
          _empty: false
        };
        Vue.pred = ret.pred
        Vue.fields = ret.fields
        ret.data['processingTime'] = processingTime
        Vue.jsonData = ret.data;
        Vue.hidingLayer()
      });
    },
    listen__image_view__onstatechange: function (data) {
      if (data.coord != undefined)
        this.state.currentFrameState.coord = {x: data.coord.x, y: data.coord.y}
      if (data.zoom != undefined)
        this.state.currentFrameState.zoom = data.zoom
      if (data.voi != undefined)
        this.state.currentFrameState.voi = {windowCenter: data.voi.windowCenter, windowWidth: data.voi.windowWidth}
      const imageView2 = this.$refs['image-view2']
      if (imageView2 != undefined) {
        imageView2.tostatechange(data)
      }
    },
    listen__btn_bbox__onclick: function () {
      this.state.bboxShow = !this.state.bboxShow;
      this.updateTagging()
    },
    listen__text_search__oninput: _.debounce(function (e) {
      this.state.searchText = e.target.value
    }, 300),
    listen__ip_dialog__done: async function (data) {
      const Vue = this
      if (Vue.frameData1.id != data.id) {
        Vue.listen__x__onfilechange(
          PARSE.encodeImage(Vue.frameData1.name, data.cornerstoneImage.getPixelData(), data.cornerstoneImage.width, data.cornerstoneImage.height),
          {keepFrameData0: true}
        )
      }
    },
    clearData: function (keepFrameData0) {
      if (keepFrameData0 == false) {
        this.frameData0 = {
          _uid: MISC.getUuid4(),
          _empty: true
        }
      }
      this.frameData1 = {
        _uid: MISC.getUuid4(),
        _empty: true
      }
      this.frameData2 = {
        _uid: MISC.getUuid4(),
        _empty: true
      }
      this.pred = []
      this.fields = []
    },
    updateTagging() {
      for (let item of this.pred) {
        const idx = this.searchTexts.findIndex((v) => item.id == v.id);
        if (idx != -1) {
          for (let row of this.pred) {
            if (row.id == item.id)
              row['active'] = this.state.bboxShow
          }
        } else {
          for (let row of this.pred) {
            if (row.id == item.id)
              row['active'] = false
          }
        }
      }

      this.$refs['image-view1'].updateTagging()
      if (this.$refs['image-view2'] != undefined)
        this.$refs['image-view2'].updateTagging()
    },
    healthCheckFunction: DocumentOCR.recognizeBusinessRegistration,
    getAddress: function () {
      const Vue = this
      return Vue.$refs['health-check'] == undefined ? '' : Vue.$refs['health-check'].getAddress()
    }
  },
  computed: {
    searchTexts: function () {
      if (this.pred.length == 0)
        return [];
      if (this.state.searchText == null || this.state.searchText.length == 0) {
        return this.pred.slice();
      } else {
        let searchTexts = [];
        for (let item of this.pred) {
          if (item.key.indexOf(this.state.searchText) != -1)
            searchTexts.push(item);
        }
        return searchTexts;
      }
    },
    searchFields: function () {
      let searchFields = [];
      for (let item of this.fields) {
        const idx = this.searchTexts.findIndex((v) => item.id == v.id);
        if (idx != -1)
          searchFields.push(item);
      }
      return searchFields;
    },
    checkPermission() {
      const Vue = this
      if (ETC.isDev())
        return true
      if (undefined != Vue.recognizeName)
        return UserJS.checkPermission(Vue.$store.state.user.permission, Vue.recognizeName)
      return true
    },
    isDev() {
      return ETC.isDev()
    },
    messagesUpload() {
      if (this.checkPermission)
        return ['\'샘플 이미지\'를 선택,', '\'파일 업로드...\'를 클릭,', '또는 이미지를 여기로 \'드래그\' 하여', '인식을 시작합니다.']
      return ['\'샘플 이미지\'를 선택 하세요.']
    },
    fileLabel() {
      if (this.checkPermission)
        return '파일 업로드...'
      return '파일 업로드 권한이 없습니다.' 
    },
    cameraLabel() {
      if (this.checkPermission)
        return '카메라 열기'
      return '카메라 권한이 없습니다.' 
    }
  },
  watch: {
    searchTexts: function () {
      this.updateTagging()
    },
    'state.currentFrameToolOption.lineWidth': function (value) {
      this.$refs['image-view1'].setToolOption('lineWidth', value)
      if (this.$refs['image-view2'] != undefined)
        this.$refs['image-view2'].setToolOption('lineWidth', value)
    }
  },
  mounted () {
    const Vue = this
    Vue.$refs['health-check'].listen__healthcheck__onclick()
  },
  created () {
    if (this.isDev) {
      this.sampleImages.push({name: '디엔에이플러스',url: 'https://api.codetabs.com/v1/proxy/?quest=https://cdn.imweb.me/upload/S201807315b6055968387c/41daa2dfbab69.jpg'})
      
      this.sampleImages.push({name: '성원애드피아',url: 'https://api.codetabs.com/v1/proxy/?quest=https://cdn.imweb.me/upload/S201807315b6055968387c/41daa2dfbab69.jpg'})
      this.sampleImages.push({name: '원대TGK',url: 'https://api.codetabs.com/v1/proxy/?quest=https://cdn.imweb.me/upload/S202011061c5bbb2f2947b/adf91b69d8eea.jpg'})
      this.sampleImages.push({name: '삼주전자',url: 'https://api.codetabs.com/v1/proxy/?quest=https://cdn.imweb.me/upload/S20160426571ece02b84e3/5b3075a5f1cfa.jpg'})
      this.sampleImages.push({name: '리그하운드',url: 'https://api.codetabs.com/v1/proxy/?quest=https://cdn.imweb.me/upload/S201807315b6055968387c/41daa2dfbab69.jpg'})
      this.sampleImages.push({name: '미리디',url: 'https://api.codetabs.com/v1/proxy/?quest=http://img1.bizhows.com/bhfile01/__CM_FILE_DATA/202104/15/14/2438331_1618465806169.jpg'})
      this.sampleImages.push({name: '시크릿그룹',url: 'https://api.codetabs.com/v1/proxy/?quest=https://cdn.nutrition2.asia/news/photo/201910/40948_20546_2835.jpg'})
    }
  }
}
</script>

<style scoped>
.rtab:not(.col) {
  flex: 0 0 400px;
}

@media (max-width: 1100px) {
  .image-tool-btn-group {
    display: none !important;
  }
}
</style>